var path = 'C:/Projects/repos/NAERS-Web/src/root.html';
var html = "<div flex layout=column> <div ui-view flex layout=column> <div flex layout=column layout-align=\"center center\" ng-if=$root.loadingView id=root-loading> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./root.html
// module id = 399
// module chunks = 0